// extracted by mini-css-extract-plugin
export default {"tag":"_u2fqx","root":"JJ6Vcq","tagsLabel":"OY6C7u","list":"zmug2R"};